import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(({ palette, spacing, themeName, breakpoints }) => ({
  carListWrap: {
    marginTop: spacing(4),
    maxWidth: 1061,
    padding: spacing(0, 2),
    [breakpoints.up('lg')]: {
      padding: 0
    }
  },

  carListItemWrap: {
    marginBottom: spacing(3),
    paddingBottom: spacing(3),
    backgroundColor: palette.background.light,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    textAlign: 'center',
    position: 'relative',
    [breakpoints.up('sm')]: {
      flexDirection: 'row',
      marginBottom: spacing(4),
      paddingLeft: 0,
      textAlign: 'left'
    }
  },
  carDetailsModelName: {
    marginBottom: spacing(3)
  },
  listItemText: {
    margin: 0,
    fontSize: 16,
    [breakpoints.up('sm')]: {
      paddingRight: '12px'
    }
  },
  listItem: {
    paddingTop: 0
  },
  listItemFlexStart: {
    marginTop: 0
  },
  paginationWrap: {
    marginTop: spacing(1),
    padding: spacing(1.5),
    backgroundColor: palette.background.light,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    [breakpoints.up('sm')]: {
      justifyContent: 'space-between'
    }
  },
  paginationItemSelected: {
    backgroundColor: palette.primary.main,
    color: palette.background.light
  },
  paginationItemIcon: {
    color: palette.primary.main,
    fontSize: 35,
    border: 0,
    'button &': {
      border: 0
    }
  },
  paginationItemPage: {
    fontSize: 16,
    fontWeight: 700,
    height: 47,
    width: 35,
    borderRadius: 0,
    margin: 0
  },
  paginationList: {
    '& > li': {
      marginLeft: spacing(0.5),
      [breakpoints.up('sm')]: {
        marginLeft: spacing(1.5)
      },
      '& button': {
        borderColor: palette.neutral.medium,
        border: '1px solid'
      },
      '&:first-child': {
        marginLeft: 0
      },
      '&:last-child': {
        border: 0
      },
      'div &': {
        border: 0
      }
    }
  },
  paginationItemEllipsis: {
    height: 47,
    border: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flexDirection: 'column'
  },
  rowsPerPageSelect: {
    justifyContent: 'center',
    fontWeight: 700,
    width: 90,
    fontSize: 16,
    backgroundColor: palette.common.white,
    border: '1px solid #cccccc',
    height: 46,
    padding: spacing(0, 1),
    marginLeft: spacing(2)
  },
  rowsPerPageIcon: {
    color: palette.primary.main,
    top: 0
  },
  carDetailsWrap: {
    padding: spacing(2),
    [breakpoints.up('sm')]: {
      marginTop: spacing(4),
      padding: 0
    }
  },
  carReservationWrap: {
    display: 'grid',
    gridTemplateRows: '1fr 1fr',
    paddingTop: spacing(2),
    gap: spacing(2),
    [breakpoints.up('sm')]: {
      gridTemplateRows: '1fr',
      gridTemplateColumns: '1fr 1fr',
      marginRight: spacing(4),
      gap: spacing(1)
    }
  },
  carReservationDaciaWrap: {
    paddingTop: spacing(2),
    [breakpoints.up('sm')]: {
      marginLeft: spacing(7),
      marginRight: spacing(4),
      maxWidth: 323
    }
  },
  carReservationButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: spacing(1),
    [breakpoints.only('sm')]: {
      padding: spacing(0.75),
      fontSize: '0.7rem'
    },
    '&:hover': {
      '& > span > svg': {
        fill: palette.common.iconCarListReservationHoverColor
      }
    }
  },
  carReservationLabel: {
    // "& svg": {
    //   marginTop: "-3px",
    // },
  },
  carReservationDialogPaperFullWidth: {
    width: '100%'
  },
  carReservationDialogPaperWidthSm: {
    maxWidth: '903px'
  },
  carReservationDialogPaperScrollBody: {
    [breakpoints.down('xs')]: {
      maxWidth: '100% !important'
    }
  },
  carReservationDialogPaper: {
    borderRadius: '0px',
    [breakpoints.down('sm')]: {
      margin: '16px auto'
    }
  },
  carReservationModalWrap: {
    overflow: 'hidden',
    padding: spacing(2.5, 1.5, 5),
    [breakpoints.up('sm')]: {
      padding: spacing(5, 5, 7.5)
    }
  },
  carDetailsList: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: spacing(2),
    [breakpoints.up('sm')]: {
      flexDirection: 'row'
    }
  },
  carListItemImg: {
    width: '100%',
    [breakpoints.up('sm')]: {
      maxWidth: '100%'
    }
  },
  chip: {
    position: 'absolute',
    top: spacing(1.25),
    left: spacing(1.25),
    ...(themeName === 'dacia' && {
      color: palette.common.engineChip,
      border: `1px solid ${palette.common.engineChip}`,
      borderRadius: '4px',
      fontSize: 14,
      fontWeight: 700
    })
  },
  carListVehiclesCount: {
    ...(themeName === 'dacia' && {
      fontSize: 24,
      textTransform: 'uppercase'
    })
  },
  listItemIcon: {
    ...(themeName === 'dacia' && {
      color: 'black',
      minWidth: 'auto',
      marginRight: spacing(2)
    })
  }
}));
